import { defineRecipe } from '@chakra-ui/react'

const outline = {
    outline: '1px solid',
    outlineOffset: 0,
    _dark: {
        outlineColor: 'surface.default',
    },
    _light: {
        outlineColor: 'dark.700',
    },
}

const search = {
    backgroundColor: 'transparent',
    border: '1px solid',
    borderColor: 'surface.dark',
    borderRadius: '4px',
    color: 'rgba(84,79,65, 0.7)',
    fontWeight: '300',
    fontSize: '12px',
    height: '32px',
    paddingLeft: '32px',
    _placeholder: {
        color: 'rgba(84,79,65, 0.7)',
        fontWeight: '300',
    },
    _dark: {
        borderColor: 'gray.600',
        color: 'rgba(255,255,255, 0.7)',
        _placeholder: {
            color: 'rgba(255,255,255, 0.7)',
        },
    },
    '&&': {
        minWidth: '230px',
    },
}

const helpCenter = {
    backgroundColor: 'transparent',
    border: '1px solid',
    borderRadius: '4px',
    width: '99.4%',
    margin: '0 0.3%',
    _placeholder: {
        color: 'rgba(84,79,65, 0.7)',
        fontSize: '16px',
        fontWeight: '300',
    },
    _light: {
        borderColor: 'dark.700',
        _hover: {
            borderColor: 'dark.700',
        },
    },
    _dark: {
        borderColor: 'surface.default',
        _hover: {
            borderColor: 'surface.default',
        },
    },
    _active: {
        ...outline,
    },
    _focus: {
        ...outline,
    },
    _focusVisible: {
        ...outline,
    },
}

const searchFile = {
    backgroundColor: 'transparent',
    _dark: {
        _placeholder: {
            color: 'rgba(255, 255, 255, 0.7)',
        },
    },
}

export const inputRecipe = defineRecipe({
    base: {
        borderRadius: 'xs',
        height: 'var(--chakra-sizes-8)',
    },
    variants: {
        variant: {
            search,
            helpCenter,
            searchFile,
        },
    },
})
